

import delegate from 'delegate';
import 'objectFitPolyfill';


const ua = window.navigator.userAgent,
  msie = ua.indexOf('MSIE '),
  trident = ua.indexOf('Trident/'),
  edge = ua.indexOf('Edge/'),
  ie = msie > 0 || trident > 0 || edge > 0;

if (!PRODUCTION) {
  console.warn(
    'UWAGA - STRONA W WERSJI DEWELOPERSKIEJ, NIESKOMPRESOWANE WERSJE PLIKÓW, BRAK WSPARCIA DLA STARYCH PRZEGLĄDAREK'
  );
}

// MESSAGE CONTAINER
delegate(
  '#messageContainer a.close, #messageContainer .cover',
  'click',
  function(e) {
    let t = document.querySelector('#messageContainer > div');

    t.remove();
    e.preventDefault();
    return false;
  },
  false
);

function getCookie(cname) {
  let name = cname + '=';
  let ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1);
    if (c.indexOf(name) != -1) return c.substring(name.length, c.length);
  }
  return '';
}

function detach(node) {
  return node.parentElement.removeChild(node);
}

//COOKIE
function clockInfoMessage() {
  function closeInfo(item, cookieName) {
    const cookieItem = document.querySelector(item);
    const cookieItemClose = document.querySelector(item + ' .close');

    function cookieInfoCheck() {
      if (cookieItem) document.querySelector(item).style.display = 'none';

      let exdate = new Date();
      exdate.setTime(exdate.getTime() + 60 * 60 * 24 * 365 * 1000);
      document.cookie =
        cookieName + '=1' + '; expires=' + exdate.toGMTString() + '; path=/';
    }

    if (cookieItemClose) {
      document
        .querySelector(item + ' .close')
        .addEventListener('click', function(event) {
          event.preventDefault();

          cookieInfoCheck();
        });
    }
  }

  closeInfo('#cookieInfoFooter', 'cmsCookieInfoCheck');
  closeInfo('#clockInfoFooter', 'cmsClockInfoCheck');

  const clockInfoFooter = document.getElementById('clockInfoFooter');

  if (clockInfoFooter) {
    if (getCookie('cmsClockInfoCheck') != 1) {
      document.getElementById('clockInfoFooter').style.display = 'block';
    }

    if (getCookie('cookieInfoFooter') != 1) {
      document.getElementById('clockInfoFooter').style.display = 'block';
    }
  }
}

clockInfoMessage();

function removeOrphans() {
  var elements = document.querySelectorAll(
    'p, .heading, .subheading, .orphan, h1, h2, h3, h4, h5, h6'
  );

  elements.forEach(item => {
    item.innerHTML = item.innerHTML.replace(/(\s)([\S])[\s]+/g, '$1$2&nbsp;');
    item.innerHTML = item.innerHTML.replace(
      /(\s)([^<][\S]{1})[\s]+/g,
      '$1$2&nbsp;'
    ); //dwuznakowe
    // item.innerHTML = item.innerHTML.replace(
    //   /(\s)([^<][\S]{2})[\s]+/g,
    //   '$1$2&nbsp;'
    // ); //trzyznakowe
  });
}
removeOrphans();

// x-ms-format-detection
document.body.setAttribute('x-ms-format-detection', 'none');






